// extracted by mini-css-extract-plugin
export default {"wrapper":"Accounts_wrapper__dnneG"};